export default "__VITE_PUBLIC_ASSET__eaa29baa__"